import React, { useState } from 'react';
import classes from '../admin/Admin.module.css';


const apiURI = `${process.env.REACT_APP_API_URI}auth/login`

function VerifyPage() {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);


    const submitHandler = async (e) => {
        e.preventDefault();

        if (password?.length > 0) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password: password })
            };
            setLoading(true)
            fetch(apiURI, requestOptions)
                .then(response => response.json())
                .then(data => {
                    setLoading(false);
                    setError(false);

                    if (data?.isAdmin) {
                        setSuccess(`Login Success!`)
                        setTimeout(() => {
                            localStorage.setItem('admin', JSON.stringify({ admin: data?.isAdmin }));
                            window.dispatchEvent(new Event("storage"));
                        }, 500);
                    } else {
                        setError('who are you?');
                    }

                })
                .catch(error => {
                    setLoading(false);
                    setSuccess(false);
                    setError('Something went wrong!');
                });

        }
        setPassword('');
    }
    return (
        <div>
            <div className={classes.wrapper}>
                <h1 style={{ color: "limegreen", marginBottom: "20px", textAlign: "center" }}>WELCOME<br />BACK</h1>
                <div className={classes.card}>
                    <form onSubmit={submitHandler}>
                        <input
                            autoFocus
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            type="password"
                        />
                        <button
                            disabled={!(password?.length > 0) || loading}
                            className={classes['my-button']}
                            type='submit'
                        >
                            {loading ? 'Loading...' : 'Enter'}
                        </button>
                    </form>
                </div>

                {(success || error) ?
                    <div className={classes.successMsg} style={{ backgroundColor: `${success ? 'rgb(68, 225, 68)' : 'red'}` }}>
                        {success || error || null}
                    </div>
                    :
                    null}
            </div>
        </div>
    )
}

export default VerifyPage;
